import styled from "styled-components";

const Subtext = styled.span`
  font-size: 0.75rem;
`;

export { Subtext };
